import {ItemAvailability} from './markup-item-availability';

export const STOCK_STATUS = Object.freeze({
  EnumGlobalStockStatus1: 'EnumGlobalStockStatus1', // In Stock
  EnumGlobalStockStatus3: 'EnumGlobalStockStatus3', // In Stores Only
  EnumGlobalStockStatus4: 'EnumGlobalStockStatus4', // Out of Stock
  EnumGlobalStockStatus5: 'EnumGlobalStockStatus5', // Coming Soon
  EnumGlobalStockStatus6: 'EnumGlobalStockStatus6', // In Warehouse
  EnumGlobalStockStatus7: 'EnumGlobalStockStatus7', // Contact Retailer
});

const stockStatusConfigTarget = {
  //In stock
  [STOCK_STATUS.EnumGlobalStockStatus1]: {
    retailerStockClass: 'status-box--in_stock',
    markupItemAvailability: ItemAvailability.IN_STOCK,
    stockStatusMessage: {
      calloutType: 'success',
      cssClass: 'text-green',
      label: 'stockInStock',
      description: 'stockInStockDescription',
      nonECommDescription: 'nonECommStockDescription',
      nonECommNonLocallyDescription: 'nonECommNonLocallyStockDescription',
      retailerLabel: (isBike) => (isBike ? 'retailerBikeInStock' : 'retailerAftermarketInStock'),
    },
  },
  //In store only
  [STOCK_STATUS.EnumGlobalStockStatus3]: {
    retailerStockClass: 'status-box--contact_retailer',
    markupItemAvailability: ItemAvailability.IN_STORE_ONLY,
    stockStatusMessage: {
      calloutType: 'warning',
      cssClass: 'text-red',
      label: 'inStoreOnly',
      // adding description since it's the fallback display value, EnumGlobalStockStatus3 will soon be deprecated
      description: 'inStoreOnly',
      retailerLabel: (isBike) => (isBike ? 'retailerBikeContactRetailer' : 'retailerAftermarketContactRetailer'),
    },
  },
  //Out of Stock
  [STOCK_STATUS.EnumGlobalStockStatus4]: {
    retailerStockClass: 'status-box--contact_retailer',
    markupItemAvailability: ItemAvailability.OUT_OF_STOCK,
    stockStatusMessage: {
      calloutType: 'error',
      cssClass: 'text-red',
      label: 'stockOutOfStock',
      description: 'stockOutOfStockDescription',
      nonECommDescription: 'nonECommStockDescription',
      nonECommNonLocallyDescription: 'nonECommNonLocallyStockDescription',
      retailerLabel: (isBike) => (isBike ? 'retailerBikeContactRetailer' : 'retailerAftermarketContactRetailer'),
    },
  },
  //Pre Sale
  [STOCK_STATUS.EnumGlobalStockStatus5]: {
    retailerStockClass: 'status-box--contact_retailer',
    markupItemAvailability: ItemAvailability.PRE_SALE,
    stockStatusMessage: {
      calloutType: 'error',
      cssClass: 'text-red',
      label: 'stockComingSoon',
      description: 'stockComingSoonDescription',
      nonECommDescription: 'nonECommStockDescription',
      nonECommNonLocallyDescription: 'nonECommNonLocallyStockDescription',
      retailerLabel: (isBike) => (isBike ? 'retailerBikeContactRetailer' : 'retailerAftermarketContactRetailer'),
    },
  },
  // In Stock - Warehouse
  [STOCK_STATUS.EnumGlobalStockStatus6]: {
    retailerStockClass: 'status-box--in_warehouse',
    markupItemAvailability: ItemAvailability.IN_STOCK,
    stockStatusMessage: {
      calloutType: 'default',
      description: 'stockInStockDescription',
      nonECommDescription: 'nonECommStockDescription',
      nonECommNonLocallyDescription: 'nonECommNonLocallyStockDescription',
      retailerLabel: (isBike) => (isBike ? 'retailerBikeInWarehouse' : 'retailerAftermarketInWarehouse'),
    },
  },
  // Contact retailer
  [STOCK_STATUS.EnumGlobalStockStatus7]: {
    retailerStockClass: 'status-box--contact_retailer',
    markupItemAvailability: ItemAvailability.BACK_ORDER,
    stockStatusMessage: {
      calloutType: 'default',
      description: 'stockComingSoonDescription',
      nonECommDescription: 'nonECommStockDescription',
      nonECommNonLocallyDescription: 'nonECommNonLocallyStockDescription',
      retailerLabel: (isBike) => (isBike ? 'retailerBikeContactRetailer' : 'retailerAftermarketContactRetailer'),
    },
  },
};

//Setup default values
const stockStatusProxyHandler = {
  get(target, prop) {
    return target[prop]
      ? target[prop]
      : {
          retailerStockClass: 'status-box--contact_retailer',
          markupItemAvailability: ItemAvailability.OUT_OF_STOCK,
          stockStatusMessage: {
            calloutType: 'default',
            retailerLabel: (isBike) => (isBike ? 'retailerBikeContactRetailer' : 'retailerAftermarketContactRetailer'),
          },
        };
  },
};

//export proxy
export const stockStatusConfig = new Proxy(stockStatusConfigTarget, stockStatusProxyHandler);
